import {
    B2CCarpayOrderView,
    B2CGetOrderByIdQuery,
    B2CGetCheckoutSessionQuery,
    DiscountType,
    SvLotType,
    LotType
} from 'parkdepot-shared/gql/graphql'
import { VoucherErrorResponseType } from './mockDataManagers/ApplyCarpayVoucherMutationManager'

export const mockedUser = {
    email: 'test-frontend-ci-booking@wemolo.de',
    password: 'test-frontend-ci-booking@wemolo.de',
    fakeToken:
        'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6Im1sNjV1UC1BTXpzU2g5ZjYyeUpxQyJ9.eyJodHRwczovL2hhc3VyYS5pby9qd3QvY2xhaW1zIjp7IngtaGFzdXJhLWFsbG93ZWQtcm9sZXMiOlsiYm9va2luZ19iMmMiXSwieC1oYXN1cmEtZGVmYXVsdC1yb2xlIjoiYm9va2luZ19iMmMiLCJ4LWhhc3VyYS1yb2xlIjoiYm9va2luZ19iMmMiLCJ4LWhhc3VyYS11c2VyLWlkIjoidGVzdC1mcm9udGVuZC1jaS1ib29raW5nQHdlbW9sby5kZSJ9LCJnaXZlbl9uYW1lIjoiVEVTVCIsImZhbWlseV9uYW1lIjoiQUNDT1VOVCIsIm5pY2tuYW1lIjoidGVzdC1mcm9udGVuZC1jaS1ib29raW5nIiwibmFtZSI6IlRFU1QgQUNDT1VOVCIsInBpY3R1cmUiOiJodHRwczovL3MuZ3JhdmF0YXIuY29tL2F2YXRhci9kNjFjZWRiYzY3N2Y2NGJlMWVkODlmMDBiMmE4OWMzOD9zPTQ4MCZyPXBnJmQ9aHR0cHMlM0ElMkYlMkZjZG4uYXV0aDAuY29tJTJGYXZhdGFycyUyRnRhLnBuZyIsInVwZGF0ZWRfYXQiOiIyMDI0LTA2LTI3VDA4OjQxOjUyLjY3MloiLCJlbWFpbCI6InRlc3QtZnJvbnRlbmQtY2ktYm9va2luZ0B3ZW1vbG8uZGUiLCJlbWFpbF92ZXJpZmllZCI6ZmFsc2UsImlzcyI6Imh0dHBzOi8vcGFyay1kZXBvdC1zdGFnaW5nLmV1LmF1dGgwLmNvbS8iLCJhdWQiOiJuU05vcmgyVDdjdGhMNHFMSjQ2UVMzeXM5M1RXelJ0VyIsImlhdCI6MTcxOTQ3NzcxMywiZXhwIjoyNDQ1MjM3NzEzLCJzdWIiOiJhdXRoMHw2NjdkMjVjZjVmN2U0ZjA2MDMwMTNlYmEifQ.HDEr0AYfAoAOuYy9FbwB81RvW0UbSilXSGNR965CIc5nyNnYrqGbt1c4Z8IdQhkLJlgMklgMC5Fh1hdVM8Zqw2QKME8AHowRFtQJAYFnQpBY9NxKGmJ5WuKHIRAz8AMpSFa47qlpoGMHY0M0nRaXIJbLdHLhLdIbMsqhdpmBpACKVDYoIbh0bp5k38Hsq57ndYQob6DVAIuIhUXIg_pYbbtgy4Ee1Xlo_zC1BrNtbbnV-E7MhrpYAmPrdBhspXdsxRIBN5-zvM4rlmd7AUGjK4SjZuCy7qjHKGzGN4t1KFv-5C-A3AeBxAlfCOfikvNsQakBBxonwp5KfF1dqn3oZQ'
}

export const emptyOrdersQueryResponse: { b2c_get_open_orders: { orders: Partial<B2CCarpayOrderView>[] } } = {
    b2c_get_open_orders: {
        orders: []
    }
}

export const emptyGetOrderByIdQueryResponseMock: B2CGetOrderByIdQuery = {
    __typename: 'query_root',
    b2c_get_order_by_id: {} as B2CCarpayOrderView
}

export const adyenCheckoutSessionQueryResponseMock: B2CGetCheckoutSessionQuery = {
    b2c_checkout: {
        adyen_id: 'mock-adyen-id',
        adyen_session_data: 'mock-session-data',
        __typename: 'B2CAdyenCheckoutResponse'
    }
}

export const applyCarpayVoucherErrorResponseMock: VoucherErrorResponseType = {
    errors: [
        {
            message: 'ORDER_NOT_FOUND: Order not found',
            extensions: {
                path: '$',
                code: 'unexpected'
            }
        }
    ]
}

export const adyenSetupQueryResponseMock = {
    amount: { currency: 'EUR', value: 1000 },
    countryCode: 'DE',
    merchantAccount: 'TestMerchant',
    reference: 'mock-reference',
    returnUrl: 'http://localhost:3000/checkout',
    paymentMethods: {
        storedPaymentMethods: [],
        paymentMethods: [
            {
                name: 'Credit Card',
                type: 'scheme'
            }
        ]
    }
}

export const getAdyenPaymentQueryResponse = (isPaymentAccepted: boolean) => ({
    resultCode: isPaymentAccepted ? 'Authorised' : 'Refused',
    pspReference: 'mock_psp_ref',
    merchantReference: 'mock_merchant_ref',
    amount: {
        currency: 'EUR',
        value: 1000
    }
})

export const adyenBinLookupResponseMock = {
    brands: [
        {
            brand: 'visa',
            enableLuhnCheck: true,
            supported: true,
            cvcPolicy: 'required',
            enabledForRecurring: true,
            panLength: 16
        }
    ],
    requestId: '1111'
}

export const carpayLotsQueryResponseMock = {
    b2c_get_carpay_lots: {
        __typename: 'B2CCarpayLots' as const,
        lots: [
            {
                lot_id: 'T001',
                name: 'Dahoam bei Wemolo',
                address: 'St.-Martin-Str. 72, 81541 München',
                longitude: 11.5666472,
                latitude: 48.1056806,
                __typename: 'B2CCarpayLotShortInfo' as const
            },
            {
                lot_id: 'T002',
                name: 'Testmarkt',
                address: 'Birkenleiten 43, 81543 München',
                longitude: 11.5666472,
                latitude: 48.1056806,
                __typename: 'B2CCarpayLotShortInfo' as const
            }
        ]
    }
}

export const carpayLotByIdQueryResponseMock = {
    b2c_get_carpay_lot: {
        lot: {
            lot_id: 'T002',
            name: 'Testmarkt',
            address: 'Birkenleiten 43, 81543 München',
            lot_type: LotType.Postpaid,
            lot_tariffs: [],
            sv_lot_type: SvLotType.Other,
            discount_types: [DiscountType.ScannedCode, DiscountType.StringInput, DiscountType.Universal],
            longitude: 11.5666472,
            latitude: 48.1056806,
            __typename: 'B2CCarpayLotInfo' as const
        },
        parking_contexts: [],
        __typename: 'B2CCarpayLotExtendedInfo'
    }
}

export const gerErrorFlowPriceQueryResponseMock = {
    b2c_get_errorflow_price: {
        order: {
            order_id: 'ERRORFLOW',
            plate: '1234',
            start_date: '2025-03-06T23:10:00+00:00',
            end_date: '2025-03-07T09:03:02.868000+00:00',
            status: 'UNPAID',
            invoice_available: false,
            __typename: 'B2CCarpayOrderInfo' as const
        },
        price: {
            currency: 'EUR',
            vat_rate: 0.19,
            price_valid_until: '2025-03-08T00:10:00+00:00',
            parking_price: 3,
            illegal_parking_price: 3,
            discounted_parking_price: 3,
            applied_discount: 0,
            billable: true,
            billable_start: '2025-03-06T23:10:00+00:00',
            billable_end: '2025-03-07T09:03:02.868000+00:00',
            payment_deadline: '2025-03-08T09:03:02.868000+00:00',
            __typename: 'B2CCarpayPriceInfo' as const
        },
        lot: {
            lot_id: 'EP001',
            name: 'Testmarkt 1',
            address: 'Birkenleiten 43, 81543 München',
            lot_type: LotType.Postpaid,
            lot_tariffs: ['P1D', 'P5D', 'P2D'],
            sv_lot_type: SvLotType.CarPark,
            discount_types: [],
            visible_toleration_time: 900,
            arrival_detection_time: 900,
            longitude: 11.5666472,
            latitude: 48.1056806,
            __typename: 'B2CCarpayLotInfo' as const
        },
        parking_contexts: [],
        scanned_codes: [],
        __typename: 'B2CCarpayOrderView' as const
    }
}
